import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { NftItemTileAuctionDetails } from '../NftItemTileAuctionDetails.tsx';
import { NftItemTileItemDetails } from '../NftItemTileItemDetails.tsx';

import styles from './styles/nftItemTileContent.scss';
import { type RegularTileContent_nftItem$key } from './__generated__/RegularTileContent_nftItem.graphql.ts';
import { type RegularTileContent_nftAuction$key } from './__generated__/RegularTileContent_nftAuction.graphql.ts';

const nftItemFragment = graphql`
    fragment RegularTileContent_nftItem on NftItem {
        ...NftItemTileItemDetails_nftItem
        ...NftItemTileAuctionDetails_nftItem
    }
`;
const nftAuctionFragment = graphql`
    fragment RegularTileContent_nftAuction on NftAuction {
        ...NftItemTileAuctionDetails_nftAuction
        status
    }
`;

type Props = {
    nftItem: RegularTileContent_nftItem$key;
    nftAuction: RegularTileContent_nftAuction$key | null | undefined;
    currency: string;
    fireTracking?: () => void;
};

export const RegularTileContent: FC<Props> = ({
    nftItem: nftItemRef,
    nftAuction: nftAuctionRef,
    currency,
    fireTracking = () => {},
}) => {
    const nftItem = useFragment(nftItemFragment, nftItemRef);
    const nftAuction = useFragment(nftAuctionFragment, nftAuctionRef);

    return (
        <div className={styles.detailsSection}>
            <NftItemTileItemDetails nftItem={nftItem} fireTracking={fireTracking} />
            <NftItemTileAuctionDetails
                nftAuction={nftAuction}
                nftItem={nftItem}
                currency={currency}
            />
        </div>
    );
};
